import { put, takeLatest } from "redux-saga/effects";
import { actionTypes } from "Redux/services/actionTypes";
import apiCall from "Redux/services/apiCall";
import { API_SERVICES } from "Redux/services/apiTypes";

// ----- Watchers -----
export function* watchFetchServiceAreasSaga() {
  yield takeLatest(actionTypes.FETCH_SERVICE_AREAS_REQUEST, fetchServiceAreasSaga);
}

export function* watchAddServiceAreaSaga() {
  yield takeLatest(actionTypes.ADD_SERVICE_AREA_REQUEST, addServiceAreaSaga);
}

export function* watchUpdateServiceAreaSaga() {
  yield takeLatest(actionTypes.UPDATE_SERVICE_AREA_REQUEST, updateServiceAreaSaga);
}

export function* watchDeleteServiceAreaSaga() {
  yield takeLatest(actionTypes.DELETE_SERVICE_AREA_REQUEST, deleteServiceAreaSaga);
}

// ----- Sagas -----
function* fetchServiceAreasSaga(action) {
  try {
    const serviceId = action.payload;
    let url = {
      type: `${API_SERVICES}${serviceId}/service-areas/`,
      apiType: "GET",
    };
    const res = yield apiCall(url);
    yield put({ type: actionTypes.FETCH_SERVICE_AREAS_SUCCESS, payload: res });
  } catch (error) {
    yield put({ type: actionTypes.FETCH_SERVICE_AREAS_FAILURE, payload: error });
  }
}

function* addServiceAreaSaga(action) {
  try {
    const { serviceId, label, mapSelection } = action.payload;
    
    // Ensure polygon is closed (first and last points must match)
    let jurisdictions = mapSelection || [];
    if (jurisdictions.length > 0) {
      const firstPoint = jurisdictions[0];
      const lastPoint = jurisdictions[jurisdictions.length - 1];
      
      // Check if polygon is not already closed
      if (firstPoint.lat !== lastPoint.lat || firstPoint.lng !== lastPoint.lng) {
        jurisdictions = [...jurisdictions, firstPoint];
      }
    }
    
    let url = {
      type: `${API_SERVICES}${serviceId}/service-areas/`,
      apiType: "POST",
      payload: {
        area_label: label,
        jurisdictions: jurisdictions,
      },
      isRaw: true,
    };
    const res = yield apiCall(url);
    yield put({ type: actionTypes.ADD_SERVICE_AREA_SUCCESS, payload: res });
  } catch (error) {
    yield put({ type: actionTypes.ADD_SERVICE_AREA_FAILURE, payload: error });
  }
}

function* updateServiceAreaSaga(action) {
  try {
    const { serviceId, areaId, label, mapSelection } = action.payload;
    
    // Ensure polygon is closed (first and last points must match)
    let jurisdictions = mapSelection || [];
    if (jurisdictions.length > 0) {
      const firstPoint = jurisdictions[0];
      const lastPoint = jurisdictions[jurisdictions.length - 1];
      
      // Check if polygon is not already closed
      if (firstPoint.lat !== lastPoint.lat || firstPoint.lng !== lastPoint.lng) {
        jurisdictions = [...jurisdictions, firstPoint];
      }
    }
    
    let url = {
      type: `${API_SERVICES}${serviceId}/service-area/${areaId}/`,
      apiType: "PATCH",
      payload: {
        area_label: label,
        jurisdictions: jurisdictions,
      },
      isRaw: true,
    };
    const res = yield apiCall(url);
    yield put({ type: actionTypes.UPDATE_SERVICE_AREA_SUCCESS, payload: res });
  } catch (error) {
    yield put({ type: actionTypes.UPDATE_SERVICE_AREA_FAILURE, payload: error });
  }
}

function* deleteServiceAreaSaga(action) {
  try {
    const { serviceId, areaId } = action.payload;
    let url = {
      type: `${API_SERVICES}${serviceId}/service-area/${areaId}/`,
      apiType: "DELETE",
    };
    const res = yield apiCall(url);
    yield put({ 
      type: actionTypes.DELETE_SERVICE_AREA_SUCCESS, 
      payload: { id: areaId } 
    });
  } catch (error) {
    yield put({ type: actionTypes.DELETE_SERVICE_AREA_FAILURE, payload: error });
  }
}
